"use client";

import Text from "@/components/common/Typography/Text";
import { useIsAuthen } from "@/hooks/auth/useIsAuthen";
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";
import { logout } from "@/lib/redux/features/user/reduce";
import {
  removeCookie,
  removeLocalStorage,
} from "@/utils/app/storage";
import {
  faChevronDown,
  faUserAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, Col, Dropdown, Row } from "antd";
import { useRouter } from "next/navigation";
import { useProfile } from "@/hooks/user/useProfile";
import { memberLabel } from "@/components/profile/LoyaltyProgram";
import { useTERouter } from "@/hooks/app/useTERouter";
import { useTranslation } from "react-i18next";

const ProfileNavigationDropdown = () => {
  const dispatch = useAppDispatch();
  const isAuthen = useIsAuthen();
  const router = useTERouter();

  const userData = useAppSelector((state) => state?.user?.profile?.data);
  const { t } = useTranslation()

  const profile = useProfile()

  const handleMenuClick = ({ key }: { key: string }) => {
    if (key === "logout") {
      // Handle logout
      dispatch(logout());
      removeLocalStorage("user");
      removeCookie("token");
      router.push("/");
    } else if (key === "my_booking") {
      if (isAuthen) {
        router.push("/profile?tab=my_booking");
      } else {
        router.push(key);
      }
    }
  };

  return (
    <Row align="middle" gutter={[15, 15]} wrap={false}>
      {/* <Col style={{ lineHeight: 1 }}>
        <Badge count={5}>
          <BellIcon style={{ fontSize: "2rem" }} />
        </Badge>
      </Col> */}
      <Col>
        <Dropdown
          placement="bottomRight"
          menu={{
            style: { minWidth: "26rem" },
            onClick: handleMenuClick,
            items: [
              {
                label: (userData ? `${userData.lastName ? ` ${userData.lastName}` : ""} ${userData.firstName || ""
                  }` : "User"),
                type: "item",
                key: "username",
              },
              {
                label: (
                  <Row className={`rank rank__${profile?.membershipData?.membershipLevel.toLowerCase()}`} style={{ marginTop: "1rem" }}>
                    <Col></Col>
                    <Col>{profile?.membershipData?.membershipLevel === 'Member' ? t("app.new_member") : `${t("app.rank")} ${t(memberLabel[profile?.membershipData?.membershipLevel])}`}</Col>
                  </Row>
                ),
                type: "item",
                key: "rank",
              },
              {
                type: "divider",
              },
              {
                label: t("app.account"),
                key: "account",
                onClick() {
                  router.push("/profile");
                },
              },
              {
                label: t("common.my_booking"),
                key: "my_booking",
              },
              {
                label: t("common.logout"),
                key: "logout",
                danger: true,
              },
            ],
          }}
        >
          <Row align="middle" gutter={5} wrap={false}>
            <Col>
              <Avatar icon={<FontAwesomeIcon icon={faUserAlt} />} />
            </Col>
            <Col>
              <Text>{userData ? `${userData.lastName ? ` ${userData.lastName}` : ""} ${userData.firstName || ""
                }` : "User"}</Text>
            </Col>
            <Col>
              <FontAwesomeIcon icon={faChevronDown} />
            </Col>
          </Row>
        </Dropdown>
      </Col>
    </Row>
  );
};

export default ProfileNavigationDropdown;
